import { createRouter, createWebHistory } from 'vue-router';
import { isAuthenticated, isMasterFull } from '@/utils/auth';
import AboutView from '../views/AboutView.vue';
import LoginForm from '@/components/LoginForm.vue';
import HomeView from '@/views/HomeView.vue';
import RoteirosView from '@/views/RoteirosView.vue';
import RoteirosmesView from '@/views/RoteirosmesView.vue';
import RoteiroPublico from '../views/RoteiroPublico.vue';
import RequisicoesList from '../views/RequisicoesList.vue';
import RequisicoesListadmin from '../views/RequisicoesListadmin.vue';
import InstrucaoView from '@/views/InstrucaoView.vue';
import RestricaoView from '@/views/RestricaoView.vue';
import FormularioView from '@/views/FormularioView.vue';
import PowerView from '@/views/PowerView.vue';
import CancelamentosAdminView from '@/views/CancelamentosAdminView.vue';


const routes = [

  {
    path: '/login',
    name: 'login',
    component: LoginForm

  },
  {
    path: '/sucesso',
    name: 'sucesso',
    component: InstrucaoView

  },
  {
    path: '/',
    name: 'instrucoes',
    component: AboutView
  },
  {
    path: '/avisorestricao',
    name: 'avisorestricao',
    component: RestricaoView
  },

  {
    path: '/agenda',
    name: 'agenda',
    meta: { requiresAuth: true },
    component: HomeView

  },

  {
    path: '/roteirosadmin',
    name: 'roteirosadmin',
    meta: { requiresAuth: true, requiresAdmin: true },
    component: RoteirosView
  },
  {
    path: '/roteirosadminmes',
    name: 'roteirosadminmes',
    meta: { requiresAuth: true, requiresAdmin: true },
    component: RoteirosmesView
  },
  {
    path: '/roteirospublic',
    name: 'roteirospublic',
    meta: { requiresAuth: true },
    component: RoteiroPublico
  },
  {
    path: '/formulario',
    name: 'formulario',
    component: FormularioView,
    props: route => ({ codigo: route.params.codigo, email: route.params.email })
  },

  {
    path: '/registros',
    name: 'registro',
    meta: { requiresAuth: true },

    component: RequisicoesList
  },
  {
    path: '/registros2',
    name: 'registro2',
    meta: { requiresAuth: true, requiresAdmin: true },
    component: RequisicoesListadmin
  },
  {
    path: '/power',
    name: 'power',
    meta: { requiresAuth: true, requiresAdmin: true },
    component: PowerView
  },
  {
    path: '/cancelamentos',
    name: 'cancelamentos',
    meta: { requiresAuth: true, requiresAdmin: true },
    component: CancelamentosAdminView
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth && !isAuthenticated()) {
    alert("Você precisa fazer sua autenticação. Faça o login na próxima página, feche a aba e confira seu e-mail, o acesso só é permitido pelo link enviado no e-mail.");
    next('/login');
  } else if (to.meta.requiresAdmin && !isMasterFull()) {
    next('/'); // ou qualquer outra rota de acesso negado que você desejar
  } else {
    next();
  }
});

export default router;
